import React from "react"
import classes from './Button.module.scss'
import iconBack from "../../../../assets/icons/button_icon_back.svg"
import iconRefresh from "../../../../assets/icons/button_icon_refresh.svg"

interface ButtonProps {
  type?: 'submit' | 'reset' | 'button'
  name?: string
  disabled?: boolean
  autoFocus?: boolean
  isLoading?: boolean
  color?: 'primary' | 'white' | 'red'
  children?: string | JSX.Element | JSX.Element[]
  className?: string
  size?: "lg" | "md" | "sm" | undefined
  onClick?: (ev: React.MouseEvent<HTMLButtonElement>) => void
  icon?: "back" | "refresh"
}

export default function Button({type = "button", name, disabled, isLoading, color, children, className, size = "md", onClick, icon}: ButtonProps) {

  const cls: string[] = [classes.button]

  if (className) {
    cls.push(className);
  }

  if (color) {
    const arColors = color.split(' ');
    arColors.forEach((color: string) => {
      cls.push(classes[color]);
    });
  } else {
    cls.push(classes['primary']);
  }

  if (size) {
    cls.push(classes[`size_${size}`])
  }

  if (isLoading) {
    cls.push(classes.loading)
  }

  return (
    <button
      type={type}
      className={cls.join(" ")}
      onClick={onClick}
      disabled={disabled}
    >
      {icon === "back" &&
        <span className={classes.icon}><img src={iconBack} alt=""/></span>
      }
      {icon === "refresh" &&
        <span className={classes.icon}><img src={iconRefresh} alt=""/></span>
      }
      {children}
    </button>
  )
}